export default {
  // get_pnbon: state => {return state.pnbon},
  // get_pcpromo: state => {return state.pcpromo},
  // get_pcdev: state => {return state.pcdev},
  // get_pmtht: state => {return state.pmtht},
  // get_pmtttc: state => {return state.pmtttc},
  // get_pmttrsp: state => {return state.pmttrsp},
  get_address: state => {return state.address}
};